<div class="register-confirmation-page">

  <div class="page-intro">
    <b3-breadcrumbs aria-label="Breadcrumb">
      <b3-breadcrumbs-item variant="icon" href="/"></b3-breadcrumbs-item>
      <b3-breadcrumbs-item variant="item">Operações de crédito</b3-breadcrumbs-item>
      <b3-breadcrumbs-item variant="item">Operações</b3-breadcrumbs-item>
      <b3-breadcrumbs-item variant="item">Confirmar crédito</b3-breadcrumbs-item>
    </b3-breadcrumbs>
    <h1 class="page-title">Confirmação de Créditos de Carbono</h1>
  </div>

  <section class="consult-content" aria-label="Confirmação de créditos de carbono">
    <div class="consult-toolbar">
      <div class="consult-filters">
        <div class="consult-filters__field consult-filters__field--search">
          <b3-input-text
            [(ngModel)]="searchCarbonCreditCode"
            inputId="searchCarbonCreditCode"
            label="Código de Inst. Financeiro"
            background="grey"
            mask="instrument"
            placeholder="Pesquisar pelo código do instrumento financeiro"
            (b3-enter)="onFilterTable()">
          </b3-input-text>
        </div>
      </div>

      <div class="consult-toolbar__action">
        <span class="consult-toolbar__label-spacer" aria-hidden="true"></span>
        <b3-button
          type="button"
          variant="outlined"
          tone="default"
          size="lg"
          class="consult-toolbar__filter-btn"
          [attr.aria-label]="filterButtonAriaLabel"
          (b3-click)="openFilterDrawer()">
          <b3-icon name="filter_alt"></b3-icon>
          <span *ngIf="activeFiltersCount > 0" class="consult-toolbar__filter-count">({{ activeFiltersCount }})</span>
          Filtrar
        </b3-button>
      </div>
    </div>

    <p class="consult-table-summary" aria-live="polite">{{ creditsFoundLabel }}</p>

    <div class="consult-table-section">
      <div class="consult-table-shell">
        <ng-container *ngIf="itens.length > 0; else emptyTableState">
          <b3-table
            size="sm"
            background="striped"
            aria-label="Lista de créditos pendentes de confirmação"
            [attr.aria-rowcount]="totalItens"
            aria-colcount="5">
            <b3-table-rowgroup group="header">
              <b3-table-row>
                <b3-table-cell-header label="Data de Emissão"></b3-table-cell-header>
                <b3-table-cell-header label="Código Conta Registrador"></b3-table-cell-header>
                <b3-table-cell-header label="Código Conta Detentor"></b3-table-cell-header>
                <b3-table-cell-header label="Código de Inst. Financeiro"></b3-table-cell-header>
                <b3-table-cell-header label="Ações" align="center"></b3-table-cell-header>
              </b3-table-row>
            </b3-table-rowgroup>

            <b3-table-rowgroup group="body">
              <b3-table-row
                *ngFor="let credit of itens; trackBy: trackByCarbonCreditCode"
                [id]="'credit-row-' + credit.carbonCreditCode">
                <b3-table-cell variant="text" [label]="credit.issueDate || '-'"></b3-table-cell>
                <b3-table-cell variant="text" [label]="credit.registerCode || '-'"></b3-table-cell>
                <b3-table-cell variant="text" [label]="credit.holderCode || '-'"></b3-table-cell>
                <b3-table-cell variant="text" [label]="credit.carbonCreditCode || '-'"></b3-table-cell>
                <b3-table-cell variant="slot">
                  <div class="consult-table-actions">
                    <b3-tooltip label="Aprovar" variant="single-line" pointer="bottom">
                      <b3-button
                        type="button"
                        variant="ghost"
                        tone="default"
                        size="sm"
                        [attr.aria-label]="getRowApproveLabel(credit)"
                        (b3-click)="onRowAction(ClickTypeEnum.APROVAR, credit)">
                        <b3-icon name="select_check_box"></b3-icon>
                      </b3-button>
                    </b3-tooltip>
                    <b3-tooltip label="Rejeitar" variant="single-line" pointer="bottom">
                      <b3-button
                        type="button"
                        variant="ghost"
                        tone="default"
                        size="sm"
                        [attr.aria-label]="getRowRejectLabel(credit)"
                        (b3-click)="onRowAction(ClickTypeEnum.REJEITAR, credit)">
                        <b3-icon name="cancel"></b3-icon>
                      </b3-button>
                    </b3-tooltip>
                    <b3-tooltip label="Detalhes" variant="single-line" pointer="bottom">
                      <b3-button
                        type="button"
                        variant="ghost"
                        tone="default"
                        size="sm"
                        [attr.aria-label]="getRowDetailsLabel(credit)"
                        (b3-click)="onRowAction(ClickTypeEnum.DETALHES, credit)">
                        <b3-icon name="visibility"></b3-icon>
                      </b3-button>
                    </b3-tooltip>
                  </div>
                </b3-table-cell>
              </b3-table-row>
            </b3-table-rowgroup>
          </b3-table>
        </ng-container>

        <ng-template #emptyTableState>
          <app-consult-table-empty-state></app-consult-table-empty-state>
        </ng-template>
      </div>

      <div class="consult-table-pagination" *ngIf="totalItens > 0">
        <p class="consult-table-pagination__info">{{ recordsPerPageLabel }}</p>
        <b3-pagination
          *ngIf="totalPages > 1"
          aria-label="Paginação de créditos pendentes de confirmação"
          variant="numbers"
          navigation="icon"
          overflow
          [attr.total]="totalPages"
          [attr.current]="pagination.page ?? 1"
          (b3-change)="onPaginationChange($event)">
        </b3-pagination>
      </div>
    </div>
  </section>

  <footer class="page-footer">
    <p class="page-footer__text">B3SA© 2026 Plataforma de Carbono. Todos os direitos reservados.</p>
  </footer>
</div>

<app-register-confirmation-filter
  [isOpen]="showFilterDrawer"
  (closed)="onFilterDrawerClosed()"
  (filtersApplied)="onDrawerFiltersApplied()">
</app-register-confirmation-filter>

<app-register-confirmation-approve-modal
  [open]="isApproveModalOpen"
  (closed)="onApproveModalClosed($event)">
</app-register-confirmation-approve-modal>

<app-register-confirmation-reject-modal
  [open]="isRejectModalOpen"
  (closed)="onRejectModalClosed($event)">
</app-register-confirmation-reject-modal>

<app-register-confirmation-details-drawer
  [isOpen]="showDetailsDrawer"
  [carbonCreditCode]="selectedCreditCodeForDetails"
  (closed)="onDetailsDrawerClosed()"
  (loadFailed)="onDetailsLoadFailed()">
</app-register-confirmation-details-drawer>

<app-register-confirmation-error-modal
  [open]="isErrorModalOpen"
  [message]="errorModalMessage"
  (closed)="onErrorModalClosed()">
</app-register-confirmation-error-modal>

<b3-toast-region class="register-confirmation-toast-region">
  <b3-toast
    *ngIf="showFilterUpdateNotice"
    [open]="true"
    variant="info"
    label="Consulta atualizada para os filtros aplicados"
    auto-dismiss
    aria-live="polite"
    (b3-close)="onFilterNoticeDismiss()">
    <b3-button
      slot="action"
      variant="ghost"
      tone="default"
      (b3-click)="onFilterNoticeUndo()">
      Desfazer
    </b3-button>
    <b3-button
      slot="close"
      variant="ghost"
      tone="default"
      aria-label="Fechar aviso de filtros"
      (b3-click)="onFilterNoticeDismiss()">
      <b3-icon name="clear" size="sm" tone="default"></b3-icon>
    </b3-button>
  </b3-toast>

  <b3-toast
    *ngIf="activeToast as toast"
    [open]="toast.open"
    [variant]="toast.variant"
    [label]="toast.label"
    [description]="toast.description"
    auto-dismiss
    (b3-close)="onToastDismiss()">
    <b3-button
      aria-label="Fechar notificação"
      (b3-click)="onToastDismiss()">
      <b3-icon name="close"></b3-icon>
    </b3-button>
  </b3-toast>
</b3-toast-region>
